module.exports = __webpack_public_path__ + "static/media/map-marker-expired.3cd9063a.png";